// Veteran Market cart helpers (Shopify Ajax API)
(function(){
  function setCount(n){ document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent='cart · '+n; }); }
  window.VMCart={
    add:function(variantId,qty){
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:qty||1}]})})
        .then(function(r){ if(!r.ok) return r.json().then(function(e){ throw new Error(e.description||e.message||'error'); }); return r.json(); })
        .then(function(){ return fetch('/cart.js').then(function(r){return r.json();}); })
        .then(function(c){ setCount(c.item_count); return c; });
    },
    change:function(key,qty){
      return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})}).then(function(r){return r.json();});
    }
  };
})();
